import { UIEventHandler } from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'

import { ChildProps } from '~/common/define/props'

interface Props extends ChildProps {
  onScroll?: UIEventHandler<HTMLDivElement>
}

const NavigationScroll = ({children, onScroll = null}: Props) => {
  return (
    <div className={styles.scroll} onScroll={onScroll}>
      {children}
    </div>
  )
}

export default NavigationScroll